import { ExternalLinks } from './environment.model';

export const defaultExternalLinks: ExternalLinks = {
  easyCalc: 'https://medias-easycalc.com/',
  medias: 'https://medias.schaeffler.com/',
  schaeffler: 'https://www.schaeffler.com/',
  grease: 'https://greaseapp.com/app',
  mounting: 'https://mountingmanager.com/app',
  rotative: 'https://bearinx.schaeffler.com/rotative/app',
  easyPlanet: 'https://bearinx.schaeffler.com/easy-planet/app',
  bearing_data_service: 'https://medias.schaeffler.de/bearing-data-service',
  training_portal:
    'https://medias.trainings.schaeffler.com/cms/courses?global_filter=Bearinx',
};
